import { OrderReferenceRequest } from '@adapters/marketplacer/returnsTypes';
import { BCOrder } from '@adapters/bigcommerce/types/order';

export async function queryOrderByReferenceInternal(
  orderReferenceRequest: OrderReferenceRequest
): Promise<{ data: Pick<BCOrder, 'id'> } | null> {
  try {
    const response = await fetch(`/api/query-order`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(orderReferenceRequest),
    });

    const result = await response.json();

    return { data: { id: result.data.id } };
  } catch (error) {
    console.error(`error making api call to submit return request: ${error}`);
    return null;
  }
}
